/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { InlineEdit } from "../../components/InlineEdit";
import { Button } from "../../components/Button";
import { useParams } from "react-router-dom";
import useSaveTemplate from "../../utils/customHooks";
import { SpinnerOverlay } from "../../utils/SpinnerOverlay";

// AD15 — KD46200WHITE BABY
// Pozycje tekstów (style inline, w mm):
//   top   = górna krawędź pola tekstowego
//   left  = środek tekstu (textAlign center + translateX(-50%)) albo lewa krawędź (textAlign left)
//   right = prawa krawędź pola (textAlign right)
// maxWidthN = maks. szerokość tekstu w px — dłuższy tekst zmniejsza czcionkę.
// Uwaga: lineHeight w stylu InlineEdit nie działa (nadpisuje go `font: inherit`), zawsze wynosi 1.5.
export const Ad15: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  const [text1, setText1] = useState<string>("Najpiękniejsze Wspomnienia");
  const [text2, setText2] = useState<string>("Marzenki");
  const [text3, setText3] = useState<string>("Kubusiu, jak się pisze");
  const [text4, setText4] = useState<string>("MIŁOŚĆ");
  const [text5, setText5] = useState<string>("?");
  const [text6, setText6] = useState<string>("Prosiaczku,");
  const [text7, setText7] = useState<string>("MIŁOŚĆ");
  const [text8, setText8] = useState<string>("się nie pisze,");
  const [text9, setText9] = useState<string>("MIŁOŚĆ");
  const [text10, setText10] = useState<string>("się czuje.");
  const text1BasicSize = 50;
  const text2BasicSize = 66;
  const text3BasicSize = 28;
  const text4BasicSize = 28;
  const text5BasicSize = 28;
  const text6BasicSize = 28;
  const text7BasicSize = 28;
  const text8BasicSize = 28;
  const text9BasicSize = 28;
  const text10BasicSize = 28;
  const [fontSizeText1, setFontSizeText1] = useState<number>(text1BasicSize);
  const [fontSizeText2, setFontSizeText2] = useState<number>(text2BasicSize);
  const [fontSizeText3, setFontSizeText3] = useState<number>(text3BasicSize);
  const [fontSizeText4, setFontSizeText4] = useState<number>(text4BasicSize);
  const [fontSizeText5, setFontSizeText5] = useState<number>(text5BasicSize);
  const [fontSizeText6, setFontSizeText6] = useState<number>(text6BasicSize);
  const [fontSizeText7, setFontSizeText7] = useState<number>(text7BasicSize);
  const [fontSizeText8, setFontSizeText8] = useState<number>(text8BasicSize);
  const [fontSizeText9, setFontSizeText9] = useState<number>(text9BasicSize);
  const [fontSizeText10, setFontSizeText10] = useState<number>(text10BasicSize);
  const { saveTemplate, isSaving } = useSaveTemplate();

  const pdfWidth = "215mm"; // PDF width in mm
  const pdfHeight = "223mm"; // PDF height in mm
  const font1 = "GreatVibes";
  const font2 = "Beryliumrg";
  const font3 = "Berylium-Bold"; // "MIŁOŚĆ"
  const maxWidth1 = 635;
  const maxWidth2 = 316;
  const maxWidth3 = 402;
  const maxWidth4 = 181;
  const maxWidth5 = 40;
  const maxWidth6 = 208;
  const maxWidth7 = 181;
  const maxWidth8 = 234;
  const maxWidth9 = 181;
  const maxWidth10 = 164;

  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number,
    fontFamily: string,
    maxWidth: number
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px ${fontFamily}`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px ${fontFamily}`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px ${fontFamily}`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  // Czekamy na załadowanie fontu, inaczej canvas mierzy tekst fontem zastępczym.
  const ensureFont = (fontFamily: string) => document.fonts.load(`1em ${fontFamily}`);

  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText1(adjustFontSize(text1, fontSizeText1, text1BasicSize, 14, font1, maxWidth1))
    );
  }, [text1]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText2(adjustFontSize(text2, fontSizeText2, text2BasicSize, 14, font1, maxWidth2))
    );
  }, [text2]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText3(adjustFontSize(text3, fontSizeText3, text3BasicSize, 10, font2, maxWidth3))
    );
  }, [text3]);
  useEffect(() => {
    ensureFont(font3).then(() =>
      setFontSizeText4(adjustFontSize(text4, fontSizeText4, text4BasicSize, 10, font3, maxWidth4))
    );
  }, [text4]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText5(adjustFontSize(text5, fontSizeText5, text5BasicSize, 10, font2, maxWidth5))
    );
  }, [text5]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText6(adjustFontSize(text6, fontSizeText6, text6BasicSize, 10, font2, maxWidth6))
    );
  }, [text6]);
  useEffect(() => {
    ensureFont(font3).then(() =>
      setFontSizeText7(adjustFontSize(text7, fontSizeText7, text7BasicSize, 10, font3, maxWidth7))
    );
  }, [text7]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText8(adjustFontSize(text8, fontSizeText8, text8BasicSize, 10, font2, maxWidth8))
    );
  }, [text8]);
  useEffect(() => {
    ensureFont(font3).then(() =>
      setFontSizeText9(adjustFontSize(text9, fontSizeText9, text9BasicSize, 10, font3, maxWidth9))
    );
  }, [text9]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText10(adjustFontSize(text10, fontSizeText10, text10BasicSize, 10, font2, maxWidth10))
    );
  }, [text10]);

  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth,
        pdfHeight: pdfHeight,
        pdfNameFromUrl: pdfNameFromUrl,
      },
      null,
      false
    );
  };

  return (
    <div style={{
      width: "100%",
      height: "100%",
      backgroundColor: "#ffffff", padding: "60px",
      position: "relative",
    }}>
      {/* Spinner Overlay */}
      <SpinnerOverlay isVisible={isSaving} />
      <div style={{ position: "absolute", top: "10px", left: "0px", right: "0px", margin: "auto", color: "white", width: "150px", height: "50px" }}>
        <Button onClick={handleSave} disabled={isSaving}>
          {isSaving ? "Zapisywanie..." : "Zapisz"}
        </Button>
      </div>

      <div
        id="printable-content"
        style={{
          position: "relative",
          width: pdfWidth,
          height: pdfHeight,
          fontFamily: "GreatVibes, Beryliumrg",
          backgroundColor: "#ffffff",
          margin: "auto",
        }}
      >
        {/* Najpiękniejsze Wspomnienia */}
        <InlineEdit
          value={text1}
          setValue={setText1}
          style={{
            fontSize: `${fontSizeText1}px`,
            fontFamily: font1,
            color: "#5a3824",
            position: "absolute",
            top: "18.6mm",
            left: "105.9mm",
            width: `${maxWidth1 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "-0.2px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* Marzenki */}
        <InlineEdit
          value={text2}
          setValue={setText2}
          style={{
            fontSize: `${fontSizeText2}px`,
            fontFamily: font1,
            color: "#5a3824",
            position: "absolute",
            top: "34.7mm",
            left: "103.6mm",
            width: `${maxWidth2 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "-0.3px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
                {/* Kubusiu, jak się pisze */}
        <InlineEdit
          value={text3}
          setValue={setText3}
          style={{
            fontSize: `${fontSizeText3}px`,
            fontFamily: font2,
            color: "#5a3824",
            position: "absolute",
            top: "172.3mm",
            right: "92.1mm",
            width: `${maxWidth3 + 5}px`,
            textAlign: "right",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* MIŁOŚĆ */}
        <InlineEdit
          value={text4}
          setValue={setText4}
          style={{
            fontSize: `${fontSizeText4}px`,
            fontFamily: font3,
            color: "#5a3824",
            position: "absolute",
            top: "172.3mm",
            left: "123.5mm",
            width: `${maxWidth4 + 5}px`,
            textAlign: "left",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* ? */}
        <InlineEdit
          value={text5}
          setValue={setText5}
          style={{
            fontSize: `${fontSizeText5}px`,
            fontFamily: font2,
            color: "#5a3824",
            position: "absolute",
            top: "172.3mm",
            left: "150.5mm",
            width: `${maxWidth5 + 5}px`,
            textAlign: "left",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* Prosiaczku, */}
        <InlineEdit
          value={text6}
          setValue={setText6}
          style={{
            fontSize: `${fontSizeText6}px`,
            fontFamily: font2,
            color: "#5a3824",
            position: "absolute",
            top: "181.3mm",
            right: "123.1mm",
            width: `${maxWidth6 + 5}px`,
            textAlign: "right",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* MIŁOŚĆ */}
        <InlineEdit
          value={text7}
          setValue={setText7}
          style={{
            fontSize: `${fontSizeText7}px`,
            fontFamily: font3,
            color: "#5a3824",
            position: "absolute",
            top: "181.3mm",
            left: "92.8mm",
            width: `${maxWidth7 + 5}px`,
            textAlign: "left",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* się nie pisze, */}
        <InlineEdit
          value={text8}
          setValue={setText8}
          style={{
            fontSize: `${fontSizeText8}px`,
            fontFamily: font2,
            color: "#5a3824",
            position: "absolute",
            top: "181.3mm",
            left: "121.7mm",
            width: `${maxWidth8 + 5}px`,
            textAlign: "left",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* MIŁOŚĆ */}
        <InlineEdit
          value={text9}
          setValue={setText9}
          style={{
            fontSize: `${fontSizeText9}px`,
            fontFamily: font3,
            color: "#5a3824",
            position: "absolute",
            top: "190.4mm",
            left: "81.2mm",
            width: `${maxWidth9 + 5}px`,
            textAlign: "left",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* się czuje. */}
        <InlineEdit
          value={text10}
          setValue={setText10}
          style={{
            fontSize: `${fontSizeText10}px`,
            fontFamily: font2,
            color: "#5a3824",
            position: "absolute",
            top: "190.4mm",
            left: "110.4mm",
            width: `${maxWidth10 + 5}px`,
            textAlign: "left",
            fontWeight: "400",
            zIndex: "12",
          }}
        />

        <img
          src="/images/AD15.svg"
          alt=""
          style={{ width: "100%", height: "100%", position: 'absolute', top: '0', left: '0', zIndex: '2' }}
        />
      </div>
    </div>
  );
};
